// extracted by mini-css-extract-plugin
export default {"moduleBase":"ModuleBase_moduleBase__y+o+r","editButton":"ModuleBase_editButton__oat6x","moduleContent":"ModuleBase_moduleContent__r+qde"};